import { faDownload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import moment from 'moment'
import { useEffect, useReducer, useState } from 'react'
import { jsonrpc } from '~/shared/api/jsonrpc'
import { Box, Chart, Header, Stat, StatLabel, StatNumber, dayLabel } from '~/shared/ui'
import { CALENDAR, PeriodFigures } from './figures'
import { usePeriod, useWindowParams } from './period'
import { useZone } from '~/team_tools/components/timezone'

enum ActionType {
    Loading = 'Loading',
    Loaded = 'Loaded',
}

const reducer = (state, action) => {
    switch (action.type) {
        case ActionType.Loading:
            return { ...state, loading: true }
        case ActionType.Loaded:
            return { ...state, loading: false, data: action.data }
        default:
            throw new Error('Unknow action')
    }
}

export const Downloads = () => {
    const [state, dispatch] = useReducer(reducer, {
        loading: false,
        data: {
            total: undefined,
            history: {},
        },
    })

    // Counted in the zone the shell names: "Today" and every chart day are
    // that zone's days, and switching the picker re-reads them.
    const [zone] = useZone()
    const period = usePeriod()
    const window = useWindowParams()

    const loader = async () => {
        dispatch({ type: ActionType.Loading })
        const resp = await jsonrpc('gameapi.statistic.downloads', {
            tz: zone,
            ...window.figure,
            monthly: period === 'all',
        })
        return resp.result
    }

    useEffect(() => {
        let live = true
        loader().then((data) => live && dispatch({ type: ActionType.Loaded, data }))
        return () => {
            live = false
        }
    }, [zone, window.key])
    return (
        <Box className='w-full text-center'>
            {/* D-098: a "download" is an account's first sign-in from the game
                client. Anyone holding the shipped client key can script one, so
                the tile names what it counts rather than claiming installs. */}
            <Header>First game logins</Header>
            <PeriodFigures
                periods={CALENDAR}
                loading={state.loading}
                value={(period) => state.data[period]}
                note={() => 'first game logins'}
                total={{ label: 'All time', value: state.data.total, note: 'first game logins' }}
                chart={{ lines: [{ label: 'First game logins', colour: '#eab308', history: state.data.history }] }}
            />
            {/* Outside the dashboard there is no window to draw, so the old
                fixed chart stays for those callers. */}
            {!period && (
                <Box.Gray className='w-full'>
                    <DownloadsChart history={state.data.history} />
                </Box.Gray>
            )}
        </Box>
    )
}

const DownloadsChart = ({ history = {} }) => {
    const [labels, setLabels] = useState<string[]>([])
    const [data, setData] = useState<number[]>([])

    useEffect(() => {
        setLabels(Object.keys(history).map(dayLabel))
        setData(Object.values(history))
    }, [history])

    return (
        <Chart.TimeSeries
            data={{
                labels,
                datasets: [
                    {
                        label: 'First game logins',
                        data: [...data],
                        borderColor: '#eab308',
                        backgroundColor: '#eab308',
                    },
                ],
            }}
        />
    )
}
